// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step3-container {
	padding: 1.5rem;
	background: #f8f9fc;
	border-radius: 8px;
}

.tabs {
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
	margin-bottom: 1rem;
}

.tab-btn {
	background: #084298;
	color: white;
	border: none;
	padding: 0.6rem 1.2rem;
	border-radius: 4px;
	cursor: pointer;
}

	.tab-btn.active {
		background: #0d6efd;
		font-weight: bold;
	}

.upload-section {
	background: #fff;
	padding: 1rem;
	border-radius: 6px;
	margin-bottom: 1rem;
	box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
}

	.upload-section label {
		font-weight: 600;
		margin-bottom: 0.5rem;
		display: block;
	}

	.upload-section input[type='file'] {
		display: block;
		margin: 0.5rem 0;
	}

.manual-btn {
	margin-top: 0.5rem;
	background: #003366;
	color: white;
	border: none;
	padding: 0.4rem 0.8rem;
	border-radius: 4px;
	cursor: pointer;
}

.file-info {
	margin-top: 0.5rem;
	color: #333;
	font-size: 0.95rem;
}

.step-nav {
	margin-top: 1rem;
	display: flex;
	justify-content: space-between;
	gap: 0.5rem;
}

	.step-nav button {
		padding: 0.6rem 1.2rem;
		border: none;
		background: #084298;
		color: white;
		border-radius: 4px;
		cursor: pointer;
	}

		.step-nav button:disabled {
			background: #ccc;
			cursor: not-allowed;
		}

.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(30, 30, 30, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
}

.modal {
	background: white;
	padding: 1.5rem;
	border-radius: 8px;
	width: 500px;
	max-width: 95%;
}

	.modal textarea {
		width: 100%;
		margin-top: 0.5rem;
		font-family: inherit;
		font-size: 1rem;
	}

.modal-actions {
	margin-top: 1rem;
	display: flex;
	justify-content: flex-end;
	gap: 0.5rem;
}

	.modal-actions button.cancel {
		background: #6c757d;
	}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/NMCPreArrival/steps/Step3CrewPassenger.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;AAChB;;CAEC;EACC,mBAAmB;EACnB,iBAAiB;CAClB;;AAED;CACC,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,sCAAsC;AACvC;;CAEC;EACC,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;CACf;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;AAED;CACC,kBAAkB;CAClB,mBAAmB;CACnB,YAAY;CACZ,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,8BAA8B;CAC9B,WAAW;AACZ;;CAEC;EACC,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;CAChB;;EAEC;GACC,gBAAgB;GAChB,mBAAmB;EACpB;;AAEF;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,iCAAiC;CACjC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,cAAc;AACf;;CAEC;EACC,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;CAChB;;AAED;CACC,gBAAgB;CAChB,aAAa;CACb,yBAAyB;CACzB,WAAW;AACZ;;CAEC;EACC,mBAAmB;CACpB","sourcesContent":[".step3-container {\n\tpadding: 1.5rem;\n\tbackground: #f8f9fc;\n\tborder-radius: 8px;\n}\n\n.tabs {\n\tdisplay: flex;\n\tgap: 0.5rem;\n\tflex-wrap: wrap;\n\tmargin-bottom: 1rem;\n}\n\n.tab-btn {\n\tbackground: #084298;\n\tcolor: white;\n\tborder: none;\n\tpadding: 0.6rem 1.2rem;\n\tborder-radius: 4px;\n\tcursor: pointer;\n}\n\n\t.tab-btn.active {\n\t\tbackground: #0d6efd;\n\t\tfont-weight: bold;\n\t}\n\n.upload-section {\n\tbackground: #fff;\n\tpadding: 1rem;\n\tborder-radius: 6px;\n\tmargin-bottom: 1rem;\n\tbox-shadow: 0 0 2px rgba(0, 0, 0, 0.1);\n}\n\n\t.upload-section label {\n\t\tfont-weight: 600;\n\t\tmargin-bottom: 0.5rem;\n\t\tdisplay: block;\n\t}\n\n\t.upload-section input[type='file'] {\n\t\tdisplay: block;\n\t\tmargin: 0.5rem 0;\n\t}\n\n.manual-btn {\n\tmargin-top: 0.5rem;\n\tbackground: #003366;\n\tcolor: white;\n\tborder: none;\n\tpadding: 0.4rem 0.8rem;\n\tborder-radius: 4px;\n\tcursor: pointer;\n}\n\n.file-info {\n\tmargin-top: 0.5rem;\n\tcolor: #333;\n\tfont-size: 0.95rem;\n}\n\n.step-nav {\n\tmargin-top: 1rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tgap: 0.5rem;\n}\n\n\t.step-nav button {\n\t\tpadding: 0.6rem 1.2rem;\n\t\tborder: none;\n\t\tbackground: #084298;\n\t\tcolor: white;\n\t\tborder-radius: 4px;\n\t\tcursor: pointer;\n\t}\n\n\t\t.step-nav button:disabled {\n\t\t\tbackground: #ccc;\n\t\t\tcursor: not-allowed;\n\t\t}\n\n.modal-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: rgba(30, 30, 30, 0.6);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 999;\n}\n\n.modal {\n\tbackground: white;\n\tpadding: 1.5rem;\n\tborder-radius: 8px;\n\twidth: 500px;\n\tmax-width: 95%;\n}\n\n\t.modal textarea {\n\t\twidth: 100%;\n\t\tmargin-top: 0.5rem;\n\t\tfont-family: inherit;\n\t\tfont-size: 1rem;\n\t}\n\n.modal-actions {\n\tmargin-top: 1rem;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: 0.5rem;\n}\n\n\t.modal-actions button.cancel {\n\t\tbackground: #6c757d;\n\t}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
